if (!customElements.get('facet-pills-mto')) {
  customElements.define(
    'facet-pills-mto',
    class FacetPillsMto extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);

        if (!window.facetPillsMtoPopstate) {
          window.facetPillsMtoPopstate = true;
          window.addEventListener('popstate', () => {
            const pills = document.querySelector('facet-pills-mto');
            if (pills) pills.update(window.location.href, false);
          });
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const link = event.target.closest('a.collection-pills-mto__pill');
        if (!link || !this.sectionId) return;
        // yeni sekmede açma vb. tarayıcıya bırakılır
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        if (link.getAttribute('aria-current') === 'page') return;
        this.update(link.href, true);
      }

      async update(href, push) {
        const url = new URL(href, window.location.origin);
        const fetchUrl = new URL(url);
        fetchUrl.searchParams.set('section_id', this.sectionId);

        const grid = document.getElementById('ProductGridContainer');
        if (grid) grid.classList.add('facet-pills-mto--loading');
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const focusedIndex = Array.from(this.querySelectorAll('a')).indexOf(document.activeElement);

        try {
          const response = await fetch(fetchUrl.toString(), { signal: controller.signal });
          if (!response.ok) throw new Error(response.status);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');

          const newGrid = html.getElementById('ProductGridContainer');
          if (grid && newGrid) grid.innerHTML = newGrid.innerHTML;

          // tüm pill grupları (genelde tek) yerinde güncellenir; kaydırma konumu değişmez
          document.querySelectorAll('facet-pills-mto').forEach((current) => {
            const fresh = html.getElementById(current.id);
            if (fresh) current.innerHTML = fresh.innerHTML;
          });

          if (push) window.history.pushState({ facetPillsMto: true }, '', url.pathname + url.search);
          if (grid && typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(grid);
        } catch (error) {
          if (error.name === 'AbortError') return;
          window.location.href = url.toString();
          return;
        } finally {
          if (grid && this.controller === controller) grid.classList.remove('facet-pills-mto--loading');
        }

        if (focusedIndex > -1) this.querySelectorAll('a')[focusedIndex]?.focus({ preventScroll: true });

        const active = this.querySelector('[aria-current="page"]');
        const list = this.querySelector('.collection-pills-mto__list');
        if (active && list && list.scrollWidth > list.clientWidth) {
          list.scrollTo({ left: active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
    }
  );
}
